export interface PageContext {
  [key: string]: unknown;
}

export type ScrollDirection = "vertical" | "horizontal";

import { setTheme } from "kido/utils";

import type { ScrollEvent } from "kido";

export class BasePage {
  protected readonly ctx: PageContext;
  protected container: HTMLElement | null;
  protected sections: HTMLElement[];

  constructor(ctx: PageContext = {}) {
    this.ctx = ctx;
    this.container = null;
    this.sections = [];
    setTheme("light");
  }

  async init(container?: Element | null): Promise<void> {
    this.container = (container as HTMLElement | null) || null;
  }

  getSections(): HTMLElement[] {
    return this.sections;
  }

  async out(): Promise<void> {}

  async in(): Promise<void> {}

  onScroll?(e: ScrollEvent): void;
}

export default BasePage;
